<template>
  <div id="userHome">
    <div class="userDetail">
      <div
        class="userHome-left"
        :style="{ marginLeft: userLeft, width: userLeftWidth }"
      >
        <div class="isShopple" @click="toggleCollapsed">
          <a-icon type="left" v-if="leftshow" />
          <a-icon type="right" v-else />
        </div>
        <div class="user-left-con">
          <a-form :form="roleForm">
            <a-row type="flex" justify="start">
              <a-col :span="8">
                <a-form-item
                  :label="$t('roleGe.RoleName')"
                  :label-col="{ span: 8 }"
                  :wrapper-col="{ span: 15 }"
                >
                  <a-input
                    :placeholder="$t('roleGe.RoleName')"
                    style="width: 100%"
                    v-decorator="['roleName']"
                  />
                </a-form-item>
              </a-col>
              <a-col style="marginTop:8px">
                <a-button
                  type="primary"
                  shape="circle"
                  icon="search"
                  size="small"
                  @click="searchRole"
                ></a-button>
              </a-col>
            </a-row>
          </a-form>
          <a-row type="flex" justify="start" style="margin: 0 0 8px 0">
            <a-col
              ><a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('roleGe.Add') }}</span>
                </template>
                <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="plus"
                  @click="addEditRole('add')"
                ></a-button> </a-tooltip
            ></a-col>
            <a-col style="margin:0 8px">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('roleGe.Edit') }}</span>
                </template>
                <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="edit"
                  style="background: #9c9446;border:none"
                  @click="addEditRole('edit')"
                ></a-button>
              </a-tooltip>
            </a-col>
            <a-popconfirm
              :title="$t('pubGicSet.AreyoudeleTask')"
              :okText="$t('pubGicSet.Yes')"
              :cancelText="$t('pubGicSet.No')"
              @confirm="deleteRole">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('roleGe.Delete') }}</span>
                </template>
                <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="delete"
                  style="background: #f5222d;border:none"
                ></a-button>
              </a-tooltip>
            </a-popconfirm>
          </a-row>

          <a-table
            :rowSelection="{
              selectedRowKeys: roleRowKeys,
              onChange: roleSelectEvent
            }"
            :dataSource="roleData"
            :columns="roleColumns"
            :pagination="NOpagination"
            :loading="roleLoading"
            size="small"
          >
            <template
              v-for="(item, index) in scopedSlotsArray"
              :slot="item"
              slot-scope="text"
            >
              <span :key="index">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span class="tableFontSize">{{
                      text == null ? "-" : text
                    }}</span>
                  </template>
                  <div class="tableFontSize">
                    {{ text == null ? "-" : text | SubLength }}
                  </div>
                </a-tooltip>
              </span>
            </template>
          </a-table>

          <a-pagination
            style="textAlign:right;margin:4px"
            size="small"
            :total="roletotalElements"
            :pageSize="roleTableSize"
            @change="rolechangePageNum"
            showQuickJumper
          />
        </div>
      </div>
      <div
        class="center-line"
        @mousedown.prevent="dragStart"
        :style="{ left: proxyDomLeft }"
      ></div>
      <div class="userHome-right" :style="{ width: userRightWidth }">
        <div class="user-right-con">
          <p class="right-con-Title">
            {{ rightType == "add" ? "Add Role" : "Edd Role" }}
          </p>
          <div style="overflow-y: auto;height: 70vh">
            <a-form :form="roleFormTop">
              <a-row type="flex" justify="start">
                <a-col :span="8">
                  <a-form-item :label="$t('roleGe.RoleName')" v-bind="formItemLayout">
                    <a-input
                      :placeholder="$t('roleGe.RoleName')"
                      style="width: 100%"
                      v-decorator="[
                        'roleName',
                        {
                          initialValue: editObj.roleName,
                          rules: [
                            {
                              required: true,
                              message: $t('publicLang.Required')
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item :label="$t('roleGe.RoleType')" v-bind="formItemLayout">
                    <a-select
                      allowClear
                      :placeholder="$t('publicLang.PleaseSelect')"
                      style="width: 100%"
                      v-decorator="[
                        'roleType',
                        {
                          initialValue: editObj.roleType,
                          rules: [
                            {
                              required: true,
                              message: $t('publicLang.Required')
                            }
                          ]
                        }
                      ]"
                    >
                      <a-select-option
                        v-for="(item, index) in roleTypeList"
                        :value="item.dataKey"
                        :key="index"
                        >{{ item.dataValue }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row type="flex" justify="start">
                <a-col :span="8">
                  <a-form-item :label="$t('roleGe.Description')" v-bind="formItemLayout">
                    <a-textarea
                      :placeholder="$t('roleGe.Description')"
                      :rows="2"
                      style="width: 100%"
                      v-decorator="[
                        'description',
                        { initialValue: editObj.description }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <a-directory-tree
              checkable
              @select="onSelect"
              :showIcon="false"
              :treeData="roleTreeList"
              v-model="checkedKeys"
              :checkedKeys="checkedKeys"
            >
            </a-directory-tree>
            <a-spin
              tip="Loading..."
              style="display: flex;align-items: center;justify-content: center"
              v-if="treeLoading"
            />
          </div>
          <a-row type="flex" justify="end">
            <a-col style="margin:4px">
              <a-button type="primary" size="small" @click="saveRole">{{ $t('publicLang.Save') }}</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
export default {
  data() {
    return {
      treeLoading: false,
      proxyDomLeft: "", // 拖拽line
      userRightWidth: "", //  右宽
      userLeft: "", // 左left
      userLeftWidth: "", // 左宽
      leftshow: true,
      //                    Table start
      scopedSlotsArray: ["role Name", "roleType", "description"],
      NOpagination: false,
      roleData: [],
      roleRowKeys: [],
      roleRows: [],
      roleTableSize: 10,
      roletotalElements: 0,
      roleLoading: true,
      formItemLayout: {
        labelCol: {
          xs: { span: 8 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 8 },
          sm: { span: 16 }
        }
      },
      //                Table End
      roleForm: this.$form.createForm(this), // 注册search From
      roleFormTop: this.$form.createForm(this),
      roleTreeList: [],
      checkedKeys: [],
      selectedKeys: [],
      roleTypeList: [],
      editObj: "",
      rightType: "add" // 添加还是编辑操作
    };
  },
    computed: {
        roleColumns(){
            return [
                {
                    title: this.$t('roleGe.RoleName'),
                    dataIndex: "RoleName",
                    scopedSlots: { customRender: "roleName" }
                },
                {
                    title: this.$t('roleGe.RoleType'),
                    dataIndex: "RoleType",
                    scopedSlots: { customRender: "roleType" }
                },
                {
                    title: this.$t('roleGe.Description'),
                    dataIndex: "Description",
                    scopedSlots: { customRender: "description" }
                }
            ]
        }
    },
  created() {
    this.roleInit();
  },
  methods: {
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
    },
    searchRole() {
      this.roleForm.validateFields((err, value) => {
        this.roleInit(1, value.roleName);
      });
    },
    roleInit(pageNum = 1, keyword = "") {
      this.treeLoading = true;
      let params = {
        pageNum: pageNum,
        pageSize: this.roleTableSize,
        keyword: keyword
      };
      ajax.get(api.ROLEFETCH, params).then(res => {
        this.roleLoading = false;
        this.roleData = res.data.content;
        this.roletotalElements = res.data.totalElements;
      });
      ajax.get(api.TYPEANDPERM).then(res => {
        this.roleTypeList = res.data.roleTypeList;
        this.roleTreeList = res.data.treeList;
        this.dataFilterData(this.roleTreeList);
        this.treeLoading = false;
      });
    },
    dataFilterData(data) {
      let checkTree = [];
      for (let i in data) {
        let aaa = data[i].children;
        for (let iii in aaa) {
          let ttt = aaa[iii].children;
          for (let iii in ttt) {
            if (ttt[iii].checked) {
              checkTree.push(ttt[iii].key);
            }
          }
        }
      }
      this.checkedKeys = checkTree;
    },
    addEditRole(type) {
      this.roleFormTop.resetFields();
      if (type == "add") {
        this.rightType = "add";
        this.editObj = {};
        ajax.get(api.TYPEANDPERM).then(res => {
          this.roleTypeList = res.data.roleTypeList;
          this.roleTreeList = res.data.treeList;
          this.dataFilterData(this.roleTreeList);
        });
      } else if (type == "edit") {
        if (this.roleRows.length != 1) {
            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
          return;
        }
        this.rightType = "edit";
        this.editObj = {};
        let params = {
          uid: this.roleRows[0].UID
        };
        ajax.get(api.FINDONE, params).then(res => {
          this.editObj = res.data;
          this.roleTypeList = res.data.list;
        });
        ajax
          .get(api.USERPERMISSION, {
            userUid: "",
            roleUid: this.roleRows[0].UID
          })
          .then(res => {
            this.roleTreeList = res.data;
            this.dataFilterData(res.data);
          });
      }
    },
    //            add edit 保存提交
    saveRole() {
      this.roleFormTop.validateFields((err, val) => {
        if (!err) {
          let getArr = this.checkedKeys;
          let paramsArr = [];
          for (let index in getArr) {
            if (isNaN(getArr[index])) {
              paramsArr.push(getArr[index]);
            }
          }
          let parasm = {};
          if (this.rightType == "add") {
            parasm = val;
          } else if (this.rightType == "edit") {
            if (this.roleRows.length != 1) {
                this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
              return;
            }
            parasm = val;
            parasm.uid = this.roleRows[0].UID;
          }
          parasm.functionList = paramsArr;
          ajax.post(api.ROLE, parasm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.roleInit();
            }
          });
        }
      });
    },
    //            删除tabel Role
    deleteRole() {
      if (this.roleRows.length < 1) {
          this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
        return;
      }
      let checkuid = [];
      this.roleRows.forEach(value => {
        checkuid.push(value.UID);
      });
      let params = {
        roleUids: checkuid
      };
      ajax.post(api.DELETEROLE, params).then(res => {
        if (res.code == 200) {
          this.roleRowKeys = [];
          this.roleInit();
        }
      });
    },
    //            分页
    rolechangePageNum(v) {
      this.roleLoading = true;
      this.roleInit(v);
    },
    //            表格checkbox
    roleSelectEvent(selectedRowKeys, selectedRows) {
      this.roleRowKeys = selectedRowKeys;
      this.roleRows = selectedRows;
    },
    //      页面拖拽伸缩
    toggleCollapsed() {
      this.leftshow = !this.leftshow;
      if (!this.leftshow) {
        this.proxyDomLeft = "20px";
        this.userLeftWidth = "20px";
        this.userRightWidth = `calc(100% - ${this.userLeftWidth})`;
      } else {
        setTimeout(() => {
          this.proxyDomLeft = "50%";
          this.userLeftWidth = this.proxyDomLeft;
          this.userRightWidth = `calc(100% - ${this.userLeftWidth})`;
        }, 300);
      }
    },
    dragStart(e) {
      let odiv = e.target;
      let disX = e.clientX - odiv.offsetLeft;
      let that = this;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let zWidth =
          document.querySelectorAll(".userDetail")[0].offsetWidth - 40;
        if (zWidth < left) {
          return false;
        }
        if (left < 20) {
          return false;
        } else {
          that.proxyDomLeft = left + "px";
          that.userLeftWidth = that.proxyDomLeft;
          that.userRightWidth = `calc(100% - ${that.userLeftWidth})`;
        }
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
};
</script>
<style lang="less">
/*抽屉框架样式*/
.tt {
}
.bg {
  background: darkseagreen !important;
}
.cc {
  background: #fff;
}
.hh {
  background: #e7eef8;
}
.ant-checkbox-group {
  .ant-checkbox-group-item {
    display: block;
    margin-top: 4px;
  }
}
.drawerCheckClass {
  .drawerCheckHeader {
    border-bottom: 1px solid #e9e9e9;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
#userHome {
  .userDetail {
    position: relative;
    height: 100%;
    overflow: hidden;
    background: #fff;
    .userHome-left {
      width: 50%;
      height: 100%;
      float: left;
      padding: 10px;
      position: relative;
      .isShopple {
        position: absolute;
        top: 0;
        right: -32px;
        z-index: 999;
        background: #efefef;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.8;
      }
      .user-left-con {
        overflow: hidden;
        .user-left-search {
          width: 500px;
          div {
            margin-right: 4px;
          }
        }
      }
    }
    .center-line {
      position: absolute;
      cursor: w-resize;
      left: 50%;
      height: 100%;
      border: 1px solid #efefef;
    }
    .userHome-right {
      float: right;
      width: calc(100% - 50%);
      height: 100%;
      padding: 10px;
      .user-right-con {
        overflow: hidden;
        .right-con-Title {
          border-bottom: 1px solid #efefef;
          width: 100%;
          padding: 10px;
          text-align: center;
        }
      }
    }
  }
}
</style>
